<template>
  <v-dialog v-model="opened" max-width="290" lazy>
    <v-card v-if="messageId">
      <v-card-text>
        {{ $t(`error_message.${messageId}`) }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn flat color="primary" @click="opened = false">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ErrorDialog',
  data () {
    return {
      opened: false,
      messageId: null
    }
  },
  methods: {
    open (messageId) {
      this.messageId = messageId
      this.opened = true
    }
  }
}
</script>

<style>
</style>
